export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14591.3c6929a7.jpg";